/**
 * Stores the tenant ID in session storage for the entire session.
 * Data persists across page refreshes but is cleared when the browser/tab is closed.
 * @param tenantId - The tenant ID to store.
 */
export function saveSessionTenantId(tenantId: string | null | undefined): void {
  if (tenantId) {
    sessionStorage.setItem('selectedTenantId', tenantId);
  }
}

/**
 * Retrieves the tenant ID from session storage.
 * @returns The stored tenant ID for the current session, or null if not found.
 */
export function getSessionTenantId(): string | null {
  return sessionStorage.getItem('selectedTenantId');
}
